<div class="d-flex justify-content-around flex-wrap dirI" [formGroup]="ajancyCostsModel">
    <div class="col-9 col-md-3 dirI">
        <label class="mb-2"> حوزه خدمت</label>

        <select class="form-select" id="domainDashbord" formControlName="iMobileDomain">
            <option value="-1">انتخاب کنید</option>
            <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>
        </select>
    </div>

    <div class="col-9 col-md-3 dirI">
        <label class="mb-2">گروه خودرو</label>

        <select id="carGroup" class="form-select" formControlName="tiMobileGroup">
            <option value="-1">انتخاب کنید</option>

            <option *ngFor="let item of groupCar" value="{{item.tiMobileGroup}}">{{item.strComment}}</option>
        </select>

    </div>
    <div class="col-9 col-md-3 dirI">
        <label class="mb-2">نوع خودرو</label>
        <select class="form-select" formControlName="tiGPSType" (change)="getAjancyCosts()">
            <option value="-1" selected>انتخاب کنید</option>
            <option *ngFor="let item of carType" value="{{item.tiGPSType}}">
                {{item.strComment}}
            </option>
        </select>
    </div>


</div>
<div class="d-flex justify-content-start mt-2 ms-3 flex-wrap dirI">
    <span class="text-danger dirI text-start w-100">نکته : تمامی هزینه ها به ریال و فاصله ها به متر و زمان به دقیقه می
        باشد </span>
</div>
<div class="d-flex justify-content-start flex-wrap dirI" [formGroup]="saveModel">
    <div class="col-xl-3 col-lg-4 col-6">
        <div class="col-11 mx-auto">
            <label>ورودی </label>
            <input type="text" class="form-control" formControlName="iEntranceFee" (keypress)="seprator($event)">
        </div>
    
    </div>
    <div class="col-xl-3 col-lg-4 col-6">
        <div class="col-11 mx-auto">
            <label> حداقل پیمایش </label>
            <input type="text" class="form-control" formControlName="iMinKM" (keypress)="seprator($event)">

        </div>
    </div>
    <div class="col-xl-3 col-lg-4 col-6">
        <div class="col-11 mx-auto">
            <label>مدت انتظار </label>
            <input type="text" class="form-control" formControlName="iMaxWait4GettingOn" (keypress)="seprator($event)">
        </div>
    </div>
    <div class="col-xl-3 col-lg-4 col-6">
        <div class="col-11 mx-auto">
            <label> هزینه توقف </label>
            <input type="text" class="form-control" formControlName="iStopFee" (keypress)="seprator($event)">

        </div>
    </div>
    <div class="col-xl-3 col-lg-4 col-6">
        <div class="col-11 mx-auto">
            <label> هزینه حرکت </label>
            <input type="text" class="form-control" formControlName="iMoveFee" (keypress)="seprator($event)">

        </div>
    </div>
    <div class="col-xl-3 col-lg-4 col-6">
        <div class="col-11 mx-auto">
            <label> هزینه هر 100 متر </label>
            <input type="text" class="form-control" formControlName="iNormalMoveFee" (keypress)="seprator($event)">
        </div>
    </div>
    <div class="col-xl-3 col-lg-4 col-6">

        <div class="col-11 mx-auto">
            <label> هزینه ساعتی </label>
            <input type="text" class="form-control" formControlName="iHorlyFee" (keypress)="seprator($event)">
        </div>
    </div>
    <div class="col-xl-3 col-lg-4 col-6">

        <div class="col-11 mx-auto">


            <label> هزینه خدمات </label>
            <input type="text" class="form-control" formControlName="iServiceFee" (keypress)="seprator($event)">

        </div>

        
    </div>
    <div class="col-xl-3 col-lg-4 col-6">
        <div class="col-11 mx-auto">
            <label> هزینه بار </label>
            <input type="text" class="form-control" formControlName="iShippingFee" (keypress)="seprator($event)">
        </div>
    </div>
    <div class="col-xl-3 col-lg-4 col-6">
        <div class="col-11 mx-auto">
            <label> درصد ورود به طرح </label>
            <input type="text" class="form-control" formControlName="iTrafficplanPercentage" (keypress)="seprator($event)"  maxlength="2">
        </div>
    </div>
    <div class="col-xl-3 col-lg-4 col-6">
        <div class="col-11 mx-auto">

            <label> درصد شبانه </label>
            <input type="text" class="form-control" formControlName="iNightPercentage" (keypress)="seprator($event)" maxlength="2">
            
        </div>
     
    </div>
    <div class="col-xl-3 col-lg-4 col-6">
        <div class="col-11 mx-auto">
            <label> ضریب دربستی </label>
            <input type="text" class="form-control" formControlName="iExclusiveFactor" (keypress)="seprator($event)" maxlength="1"> 
        </div>
       
    </div>

</div>
<div class="d-flex justify-content-center mt-2" >
    <button class="btn btn-primary" (click)="saveAjancyCosts()">
        ذخیره اطلاعات
    </button>
</div>